import { initialize, stockVisibility, StockResponse } from '@fe-sdk/cbx-stocks'
import { ProductStockData } from './types'
import MockData from '../../components/organisms/ConfigureAndBuy/api-mock-stock-data.mock'
import { SDK_INITIALIZE_CONFIG } from '../sdk-config'

initialize(SDK_INITIALIZE_CONFIG)

export type ProductStockOrResponse<
  T = ProductStockData[] & { status?: number }
> = T | { data?: StockResponse; status: number }

export const getStockFromData = <T = ProductStockData[] & { status?: number }>(
  data: ProductStockOrResponse<T> | undefined
): T | undefined => {
  if (!data) {
    return undefined
  }
  if (typeof data === 'object' && 'data' in data && data.data) {
    const apiResponse = data.data as StockResponse

    if ('products' in apiResponse && Array.isArray(apiResponse.products)) {
      return apiResponse.products as T
    }

    const stockData =
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'data' in apiResponse ? (apiResponse as any).products : apiResponse
    return {
      ...(stockData as { data: object })
    } as T
  }

  return data as T
}

export const getProductsStockData = async <T = ProductStockData[]>({
  cbxUrl,
  market,
  channel,
  xChannel,
  articleList = [],
  isMock = false,
  customHeaders
}: {
  cbxUrl: string
  market: string
  channel: string
  xChannel: string
  loggerEnabled: boolean
  articleList: string[]
  isMock?: boolean
  customHeaders?: [string, string][]
}): Promise<T | undefined> => {
  if (isMock) {
    const mockSdkResponse = {
      data: {
        data: {
          products: MockData
        }
      },
      status: 200
    }
    return getStockFromData<T>(mockSdkResponse as ProductStockOrResponse<T>)
  }

  const sdkResponse = await stockVisibility({
    baseURL: cbxUrl ?? '',
    articleList,
    channel: channel ?? '',
    xChannel: xChannel || 'WEBSITE',
    market: market ?? '',
    countryCode: market?.toUpperCase() ?? '',
    ...(customHeaders ? { customHeaders } : {})
  })

  return getStockFromData<T>(sdkResponse as ProductStockOrResponse<T>)
}

export default {
  getProductsStockData
}
